export default [
  { key: "Authenticate" },
  { key: "Home"},
  { key: "Admin"},
];
